module.exports = __webpack_public_path__ + "images/2-i11a51604fbd917273be52c2bb47c335365.svg";